import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { RouterModule } from '@angular/router'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import { forgotPassword } from '../../../store/auth/auth.actions'
import { selectLoading } from '../../../store/auth/auth.state'
import { eps } from '../../../services/url.service'
import { StrictEmailDirective } from '../../../directives/strict-email.directive'
import { SharedModule } from '../../../shared/shared.module'

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    StrictEmailDirective,
    SharedModule
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  store = inject(Store)
  form: FormGroup
  text = 'Password Reset was sent to your inbox'
  currentYear: number
  isLoading$ = this.store.pipe(select(selectLoading))
  eps = eps

  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    this.currentYear = new Date().getFullYear() // Get current year

    this.form = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]]
    })
    // console.log('form validation:', this.form.valid)
  }

  reset() {
    if (this.form.invalid) return

    // const email = this.form.value.email
    // this.store.dispatch(forgotPassword({ email }))
    if (this.form.valid) {
      this.store.dispatch(forgotPassword(this.form.value))
    }
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
    }
    return null // No error
  }

  get copyrightText(): SafeHtml {
    const copyrightSymbol = '\u00A9' // Unicode for ©
    const text =
      this.currentYear === 2025
        ? `Copyright ${copyrightSymbol} 2025 - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`
        : `Copyright ${copyrightSymbol} 2025 - ${this.currentYear} - <a href="https://avrtechno.com" class="hover-a">AVR Software Pvt. Ltd.</a>`

    return this.sanitizer.bypassSecurityTrustHtml(text)
  }
}
